import './beta.scss';
import React from 'react';
export const Beta = () => (<span className="main-menu__badge-beta" data-test-id="beta-lable">beta</span>);
